var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.03 25.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finanzen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.02,7.29c0-.08-.02-.16-.05-.24,0-.03-.02-.06-.03-.09-.04-.1-.1-.19-.18-.27L15.34.27c-.08-.08-.17-.14-.27-.18-.03-.01-.06-.02-.09-.03-.08-.03-.16-.04-.24-.05-.02,0-.04-.01-.06-.01H.92C.41,0,0,.41,0,.92v23.87c0,.51.41.92.92.92h20.19c.51,0,.92-.41.92-.92V7.34s0-.04-.01-.06Zm-3.12-.86h-3.29v-3.29l3.29,3.29ZM1.84,23.87V1.84h11.93v5.51c0,.51.41.92.92.92h5.51v15.6H1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.44,9.18H4.59c-.51,0-.92.41-.92.92s.41.92.92.92h12.85c.51,0,.92-.41.92-.92s-.41-.92-.92-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.59,6.43h6.43c.51,0,.92-.41.92-.92s-.41-.92-.92-.92h-6.43c-.51,0-.92.41-.92.92s.41.92.92.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.44,13.77H4.59c-.51,0-.92.41-.92.92s.41.92.92.92h12.85c.51,0,.92-.41.92-.92s-.41-.92-.92-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.44,18.36H4.59c-.51,0-.92.41-.92.92s.41.92.92.92h12.85c.51,0,.92-.41.92-.92s-.41-.92-.92-.92Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.ce834f1ca9c575c30ecc916f3ff85b71.svg";
export { ForwardRef as ReactComponent };